import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SESSION_TIMEOUT = 15 * 60 * 1000; // 15 minutes
const WARNING_TIME = 2 * 60 * 1000; // 2 minutes before timeout

export default function UseSessionTimeout({ children }) {
    let timeout;
    let warningTimeout;

    // Reset session timeout and warning on any user activity
    const resetSessionTimeout = () => {
        clearTimeout(timeout);
        clearTimeout(warningTimeout);

        warningTimeout = setTimeout(() => {
            // alert("Your session is about to expire. Please click to stay logged in.");
        }, SESSION_TIMEOUT - WARNING_TIME); // Show warning before session ends

        timeout = setTimeout(() => {
            // alert("Session expired. You will be logged out.");
            sessionStorage.clear();
            window.location.href = '/';  // Use navigate instead of window.location.href
        }, SESSION_TIMEOUT);
    };

    useEffect(() => {
        // Monitor mouse move, key press, and click to reset timeout
        window.addEventListener("mousemove", resetSessionTimeout);
        window.addEventListener("keydown", resetSessionTimeout);
        window.addEventListener("click", resetSessionTimeout);

        resetSessionTimeout(); // Initial timeout setup

        return () => {
            clearTimeout(timeout);
            clearTimeout(warningTimeout);
            window.removeEventListener("mousemove", resetSessionTimeout);
            window.removeEventListener("keydown", resetSessionTimeout);
            window.removeEventListener("click", resetSessionTimeout);
        };
    }, []);

    return <>{children}</>; // Ensure it renders children
}
